import { extend } from 'flarum/common/extend';
import PostUser from 'flarum/forum/components/PostUser';
app.initializers.add('val-ui-post-user-group-color', () => {
  extend(PostUser.prototype, 'view', function (vnode) {
    const post = this.attrs.post;
    const user = post && typeof post.user === 'function' ? post.user() : null;
    if (!user || typeof user.groups !== 'function') {
      return;
    }
    const groups = user.groups();
    if (!Array.isArray(groups) || !groups.length) {
      return;
    }

    /*
     * Premier groupe possédant réellement une couleur.
     */
    const coloredGroup = groups.find(group => {
      if (!group || typeof group.color !== 'function') {
        return false;
      }
      const color = group.color();
      return typeof color === 'string' && color.trim() !== '';
    });
    if (!coloredGroup) {
      return;
    }
    const color = coloredGroup.color();
    if (!vnode || !vnode.attrs) {
      return;
    }
    vnode.attrs.className = (vnode.attrs.className || '') + ' val-post-user-group-colored';
    vnode.attrs.style = Object.assign({}, vnode.attrs.style || {}, {
      '--val-post-user-group-color': color
    });
  });
});